import Constants from '../actions/types';

const initialState = {
  rules: [],
  loading: false,
  message: null,
  severity: null
};

const singleBestRecordReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.SINGLEBESTRECORD_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.SINGLEBESTRECORD_GET_SUCCESS: {
      const newState = {
        ...state,
        rules: action.payload.rules,
        loading: false
      };

      return newState;
    }

    case Constants.SINGLEBESTRECORD_GET_FAILURE: {
      const newState = {
        ...state,
        rules: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.SINGLEBESTRECORD_SAVE_SUCCESS: {
      const newState = {
        ...state,
        loading: false,
        message: 'The single best record configuration was saved successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.SINGLEBESTRECORD_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.SINGLEBESTRECORD_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default singleBestRecordReducer;
